export const STATUS = { ny: "Ny", planlagt: "Planlagt", paagaar: "Pågår", ferdig: "Ferdig", fakturert: "Fakturert" };
export const INQ_STATUS = { ny: "Ny", under_behandling: "Under arbeid", konvertert: "Konvertert", avvist: "Avvist" };
export const PRIORITY = { lav: "Låg", normal: "Normal", hoeg: "Høg", akutt: "Akutt" };
export const MARKET = { industri: "Industri", samferdsel: "Samferdsel", bygg_naering: "Bygg og næring", service_bustad: "Service og bustad" };
export const ORDER_TYPE = { service: "Service", feilretting: "Feilretting", installasjon: "Installasjon", oppgradering: "Oppgradering", prosjekt: "Prosjekt", kontroll: "Kontroll", befaring: "Befaring", tilbod: "Tilbod" };
export const CUSTOMER_TYPE = { privat: "Privat", naering: "Næring", industri: "Industri", offentleg: "Offentleg" };
export const NEED = { befaring: "Befaring", tilbod: "Tilbod", direkte_oppdrag: "Direkte oppdrag", meir_info: "Treng meir info" };
export const SCOPE = { lite: "Lite", middels: "Middels", stort: "Stort" };
export const QUOTE_STATUS = { utkast: "Utkast", sendt: "Sendt", vunne: "Vunne", tapt: "Tapt" };
export const DOC_STATUS = { komplett: "Komplett", manglar: "Manglar", boer_sjekkast: "Bør sjekkast" };
export const ROLE = { leiar: "Leiar", prosjektleiar: "Prosjektleiar", kontor: "Kontor", montor: "Montør" };

const MONTHS = ["jan.", "feb.", "mars", "apr.", "mai", "juni", "juli", "aug.", "sep.", "okt.", "nov.", "des."];
const DAYS = ["sundag", "måndag", "tysdag", "onsdag", "torsdag", "fredag", "laurdag"];

function parse(d) {
  if (!d) return null;
  if (d instanceof Date) return d;
  if (/^\d{4}-\d{2}-\d{2}$/.test(d)) {
    const [y, m, day] = d.split("-").map(Number);
    return new Date(y, m - 1, day);
  }
  const dt = new Date(d);
  return isNaN(dt) ? null : dt;
}

export function todayISO() {
  const n = new Date();
  return `${n.getFullYear()}-${String(n.getMonth() + 1).padStart(2, "0")}-${String(n.getDate()).padStart(2, "0")}`;
}

export function addDays(iso, n) {
  const d = parse(iso) || new Date();
  d.setDate(d.getDate() + n);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

export function fmtDate(d, withYear = true) {
  const dt = parse(d);
  if (!dt) return "–";
  return `${dt.getDate()}. ${MONTHS[dt.getMonth()]}${withYear ? ` ${dt.getFullYear()}` : ""}`;
}

export function fmtDayLong(d) {
  const dt = parse(d);
  if (!dt) return "–";
  const s = `${DAYS[dt.getDay()]} ${dt.getDate()}. ${MONTHS[dt.getMonth()]} ${dt.getFullYear()}`;
  return s.charAt(0).toUpperCase() + s.slice(1);
}

export function fmtTime(d) {
  const dt = parse(d);
  if (!dt) return "–";
  return `${String(dt.getHours()).padStart(2, "0")}:${String(dt.getMinutes()).padStart(2, "0")}`;
}

export function fmtDateTime(d) {
  const dt = parse(d);
  if (!dt) return "–";
  return `${fmtDate(dt)} kl. ${fmtTime(dt)}`;
}

export function relDay(iso) {
  if (!iso) return "Ikkje planlagt";
  const t = todayISO();
  if (iso === t) return "I dag";
  if (iso === addDays(t, 1)) return "I morgon";
  if (iso === addDays(t, -1)) return "I går";
  return fmtDate(iso, false);
}

export function fmtNOK(n) {
  const v = Math.round(Number(n || 0));
  return `${v.toLocaleString("nb-NO").replace(/\u00a0/g, " ")} kr`;
}

export function fmtHours(h) {
  const v = Number(h || 0);
  return `${v.toLocaleString("nb-NO", { minimumFractionDigits: 0, maximumFractionDigits: 2 })} t`;
}

export function initials(name) {
  return (name || "")
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((s) => s[0])
    .join("")
    .toUpperCase();
}

export function timeAgo(iso) {
  const dt = parse(iso);
  if (!dt) return "";
  const diff = (Date.now() - dt.getTime()) / 1000;
  if (diff < 60) return "nett no";
  if (diff < 3600) return `${Math.floor(diff / 60)} min sidan`;
  if (diff < 86400) return `${Math.floor(diff / 3600)} t sidan`;
  const days = Math.floor(diff / 86400);
  if (days === 1) return "i går";
  if (days < 7) return `${days} dagar sidan`;
  return fmtDate(dt, false);
}
